<template>
  <div>
     <section id="createapp" class="section-createapp pd-section">
      <div class="container">
        <div class="col-md-5">
          <div class="text-center pb-5">
            <img class="img-fluid mb-5" src="images/logo/logo-createapp.png" alt="brand-createapp" width="250">
            <br>
            <img class="img-fluid hvr-grow" src="images/icon/icon-createapp2.png" alt="icon-createapp"
              width="200">
          </div>
          <p>CreateApp adalah platform pengembangan aplikasi seluler Do-It-Yourself yang dibuat khusus untuk
            bisnis kecil dan menengah untuk tumbuh dalam ekonomi seluler.</p>
          <a href="https://www.createapp.com/" target="_blank" rel="noopener" class="hvr-underline-from-left"
            title="Selengkapnya">Lebih lagi</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Atozcreate"
  }
</script>

<style scoped>

</style>